var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSummaryDeclarationsIcon = function SvgSummaryDeclarationsIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D7C54",
    strokeWidth: 0.8,
    d: "m3.952 10.411.843 1.014L6.56 9.922M3.952 14.206l.843 1.014 1.766-1.503M3.952 18l.843 1.015 1.766-1.503"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1E22",
    d: "M8.307 10.844h5.618M8.307 14.64h5.618M8.307 18.434h5.618"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBE00",
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M18.187 1v3.185M16.557 2.583h3.261"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1E22",
    d: "M3.098 3.194h8.654l4.929 4.976v13.3c0 .962-.78 1.742-1.743 1.742H3.098c-.962 0-1.742-.78-1.742-1.742V4.936c0-.962.78-1.742 1.742-1.742Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1E22",
    d: "M11.756 3.203v3.332c0 .962.78 1.742 1.742 1.742h3.121"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSummaryDeclarationsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/Summary_Declarations_Icon.d4bc197a97d467408b36fdacc5e390f9.svg";